<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
.tr3{position: relative;
  ul{list-style: none;display: flex;margin: 0px;margin-left: -25px;}
  .text{margin-top: 16px;}
  .el-input{width: 93px;margin: 0px 10px;}
}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form >
        <table class="dmkclb">
          <tr class="tr tr2">
            <td>
              <el-form-item>
                <div class="td">
                  <el-button type="success" v-if='addbu' @click="addfn()">添加</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="username" label="添加人"> </el-table-column>
          <el-table-column label="背景图" >
            <template slot-scope="scope">
              <img :src="scope.row.thumb" width="500px" height="160px" class="head_pic"/>
            </template>
          </el-table-column>
          <el-table-column label="添加时间">
            <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" @click="deletefn(11, 111, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button class="elbtn delete" @click="deletesfn(11, 111)">批量删除</el-button>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/***
 * 李旭
 * 矿业论坛标题列表页
 */
import filters from '../method/filter'
import {mapState} from 'vuex'
export default {
  mixins: [filters],
  data()
  {
    return {
      count: 20,
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      show1: false,
      show2: false,
      show3: false,
      parms: '',
      urlShow: '',
      isdialogVisible: false,
      addbu: false
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
      //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      let count = this.count
      let currentPage = this.currentPage
      let exp = ''
      exp = 'id > 0'
      let paras = {cmd: 'query', _major: 11, _minor: 111, _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret[0].total > 0)
        {
          this.addbu = false
          this.countSum = ret[0].total
          this.tableData = []
          ret[0].data.forEach((item) =>
          {
            this.tableData.push({
              id: item.id,
              name: item.name,
              thumb: item.thumb,
              username: item.username,
              addtime: item.addtime
            })
          })
        }
        else
        
          this.addbu = true
      })
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/KyltTitleUpdate', query: {id: row.id}})
    },
    //点击查看地图
    preview1(url)
    {
      if (url)
        window.open(url, '_blank')
      else
        this.$message({message: '您还没有上传地图', type: 'error', customClass: 'mzindex'})
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab4')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.count)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/KyltTitleLB.vue